import * as Api from '@ViewModels';
import * as React from 'react';
import { createContext, useCallback, useState } from 'react';
import { ScheduleMeetingErrorModal } from '../ScheduleMeetingErrorModal';
import { IErrorContext } from '../types';

const ErrorContext = createContext<IErrorContext>(null);

export const ErrorProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
	const [error, setError] = useState<Api.IOperationResultNoValue>(undefined);

	const onClose = useCallback(() => {
		setError(null);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [error]);

	return (
		<ErrorContext.Provider value={{ setError }}>
			{error && <ScheduleMeetingErrorModal error={error} onClose={onClose} />}
			{children}
		</ErrorContext.Provider>
	);
};

export const useErrorMessage = () => {
	const context = React.useContext(ErrorContext);
	if (!context) {
		throw new Error('userError can only be used within the <ScheduleMeetingApp /> component');
	}
	return context;
};
